import React from 'react'
import { IconDownload, IconFile } from '@tabler/icons-react'

interface PreviewUnsupportedFilesProps {
  title: string
  onDownload: () => void
}

export const PreviewUnsupportedFiles: React.FC<PreviewUnsupportedFilesProps> = ({
  title,
  onDownload
}) => (
  <div className="flex h-full flex-col items-center justify-center gap-1 p-2 text-center">
    <IconFile size={40} className="theme-icon-muted" aria-hidden="true" />
    <p className="theme-text-heading font-semibold mb-0">
      Preview isn&apos;t available for this file type
    </p>
    <p className="theme-text-subheading mb-1 break-words">{title}</p>
    <button
      type="button"
      className="flex items-center gap-50 rounded-md bg-primary px-1 py-50 text-white"
      onClick={onDownload}>
      <IconDownload size={16} aria-hidden="true" />
      Download document
    </button>
  </div>
)
